import {useEffect, useState} from "react";
import appConstants from '../../../../constants';
import {toggleFilterValue, selectAllFilterValues} from '../../helpers';

const defaults = Object.freeze({
  initialSelectedPartnerLevels: []
});

export function getComputedPartnerLevelList(
  selectedPartnerRoleCode,
  partnerIntegratorLevelList,
  partnerProviderLevelList,
  partnerDeveloperLevelList,
  partnerAdvisorLevelList
) {
  switch (selectedPartnerRoleCode) {
    case appConstants.VALUE_INTEGRATOR : { return selectAllFilterValues(partnerIntegratorLevelList); }
    case appConstants.VALUE_PROVIDER :   { return selectAllFilterValues(partnerProviderLevelList);}
    case appConstants.VALUE_DEVELOPER:   { return selectAllFilterValues(partnerDeveloperLevelList); }
    case appConstants.VALUE_ADVISOR:     { return selectAllFilterValues(partnerAdvisorLevelList); }
    default: {
      return [];
    }
  }
}

export default function usePartnerLevelFilter(
  selectedPartnerRoleCode,
  partnerIntegratorLevelList,
  partnerProviderLevelList,
  partnerDeveloperLevelList,
  partnerAdvisorLevelList,
  resetPartnerRoleFilterValuesFn,
  initialSelectedPartnerLevels = defaults.initialSelectedPartnerLevels) {
  const [isPartnerLevelFilterDropdownOpened, setIsPartnerLevelFilterDropdownOpened] = useState(false);
  const [partnerLevelFilterValues, setPartnerLevelFilterValues] = useState([]);

  const [selectedPartnerLevels, setSelectedPartnerLevels] = useState(initialSelectedPartnerLevels);

  function togglePartnerLevelFilterValue(partnerLevelFilterValue) {
    const updatePartnerLevelFilterOperationResults =
      toggleFilterValue(partnerLevelFilterValue, partnerLevelFilterValues);
    if (updatePartnerLevelFilterOperationResults.areFilterValuesUpdated) {
      if(updatePartnerLevelFilterOperationResults.selectedFilterValueCount === 0) {
        resetPartnerRoleFilterValuesFn();
      }
      setPartnerLevelFilterValues(previousValue => [...updatePartnerLevelFilterOperationResults.updatedFilterValues]);
      setIsPartnerLevelFilterDropdownOpened(previousValue => false);
      setSelectedPartnerLevels((previousValue) => [...updatePartnerLevelFilterOperationResults.updatedFilterValues.filter((partnerLevel) => partnerLevel[appConstants.KEY_IS_SELECTED] === true)]);
    }
  }
  function resetPartnerLevelFilterValues() {
    const computedPartnerLevelList = getComputedPartnerLevelList(selectedPartnerRoleCode, partnerIntegratorLevelList, partnerProviderLevelList);
    setPartnerLevelFilterValues(previousValue => [...computedPartnerLevelList]);
    setSelectedPartnerLevels((previousValue) => [...computedPartnerLevelList.filter((partnerLevel) => partnerLevel[appConstants.KEY_IS_SELECTED] === true)]);
  }
  function togglePartnerLevelFilterDropdown() {
    setIsPartnerLevelFilterDropdownOpened(previousValue => !isPartnerLevelFilterDropdownOpened);
  }


  useEffect(
    () => {
      let updatedPartnerLevelList = getComputedPartnerLevelList(selectedPartnerRoleCode, partnerIntegratorLevelList, partnerProviderLevelList, partnerDeveloperLevelList, partnerAdvisorLevelList);
      if ((initialSelectedPartnerLevels !== null) && Array.isArray(initialSelectedPartnerLevels)) {
        initialSelectedPartnerLevels.forEach((selectedPartnerLevel) => {
          updatedPartnerLevelList = updatedPartnerLevelList.map((partnerLevel) => partnerLevel[appConstants.KEY_CODE] === selectedPartnerLevel[appConstants.KEY_CODE]?selectedPartnerLevel:partnerLevel)
        });
      }
      setPartnerLevelFilterValues(previousValue => [...updatedPartnerLevelList]);
      setSelectedPartnerLevels(previousValue => [...updatedPartnerLevelList.filter((partnerLevel) => partnerLevel[appConstants.KEY_IS_SELECTED] === true)])
    },
    [partnerIntegratorLevelList, partnerProviderLevelList, partnerDeveloperLevelList, partnerAdvisorLevelList, selectedPartnerRoleCode, initialSelectedPartnerLevels, initialSelectedPartnerLevels]
  );


  return {
    isPartnerLevelFilterDropdownOpened,
    partnerLevelFilterValues,
    togglePartnerLevelFilterValue,
    resetPartnerLevelFilterValues,
    togglePartnerLevelFilterDropdown,
    selectedPartnerLevels
  }

}

